<template>
  <v-container>
    <ActiveRepos />
    <ObservationList v-if="localAccount" />
    <MeasurementDefinitionList v-if="localAccount" />
  </v-container>
</template>
<script setup lang="ts">
import { localAccount } from "../authenticationTokens";
</script>
